import React from 'react';
import { MainContainer } from '../components';
import AboutHead from '../assets/AboutUs/aboutus.jpg';

function Services() {


    const SERVICES = [
        {
            id: 0,
            image: "image1.jpg", // Replace with actual image filename or path
            title: "Solar Power Plant Installations",
            description: "Expert installations for efficient solar power plants.",
        },
        {
            id: 1,
            image: "image2.jpg", // Replace with actual image filename or path
            title: "Solar Structure Designing & Best Fit Project Site",
            description: "Tailored designs and strategic planning for optimal solar projects.",
        },
        {
            id: 2,
            image: "image3.jpg", // Replace with actual image filename or path
            title: "Net Metering Liaison & Documentation",
            description: "Efficient handling of net metering processes and documentation.",
        },
        {
            id: 3,
            image: "image4.jpg", // Replace with actual image filename or path
            title: "Solar Site Survey",
            description: "Thorough surveys for accurate solar project assessments.",
        },
    ];

    const SOLUTIONS = [
        {
            id: 0,
            image: "path/to/image1.jpg",
            title: "RCC TYPE PRE & POST GALVANISED",
            description: "Durable galvanized RCC structures for robust solar installations.",
        },
        {
            id: 1,
            image: "path/to/image2.jpg",
            title: "MONO RAIL ALUMINIUM",
            description: "Aluminum mono rail design for efficient and reliable solar mounting.",
        },
        {
            id: 2,
            image: "path/to/image3.jpg",
            title: "RCC BALLAST GI STRUCTURE",
            description: "GI structured ballast system ensuring stability and longevity.",
        },
        {
            id: 3,
            image: "path/to/image4.jpg",
            title: "LONG RAIL ALUMINIUM",
            description: "Aluminum long rail design for flexible and scalable solar projects.",
        },
        {
            id: 4,
            image: "path/to/image5.jpg",
            title: "SOLAR HUT SHAPE STRUCTURE",
            description: "Innovative hut-shaped structures for aesthetically pleasing solar installations.",
        },
        {
            id: 5,
            image: "path/to/image6.jpg",
            title: "SOLAR GROUND-MOUNTED STRUCTURE",
            description: "Ground-mounted structures for efficient solar power generation.",
        },
    ];

    const PRODUCTS = [
        {
            id: 0,
            image: "path/to/image1.jpg",
            title: "GI STRUT SECTION",
            description: "Versatile and durable GI strut sections for robust solar structures."
        },
        {
            id: 1,
            image: "path/to/image2.jpg",
            title: "C-LIP SECTION",
            description: "C-Lip sections designed for secure and efficient solar module mounting."
        },
        {
            id: 2,
            image: "path/to/image3.jpg",
            title: "C SECTION",
            description: "High-quality C sections ensuring stability in solar mounting solutions."
        },
        {
            id: 3,
            image: "path/to/image4.jpg",
            title: "PERFORATED GI STRUT SECTION",
            description: "Perforated GI strut sections for enhanced ventilation and support."
        },
        {
            id: 4,
            image: "path/to/image5.jpg",
            title: "HAT PURLIN",
            description: "Sturdy and reliable hat purlins for effective solar module installation."
        },
        {
            id: 5,
            image: "path/to/image6.jpg",
            title: "GI STRIP",
            description: "GI strips designed for securing and fastening solar mounting structures."
        },
        {
            id: 6,
            image: "path/to/image7.jpg",
            title: "CABLE TRAY",
            description: "Cable trays for organized and efficient cable management in solar projects."
        },
        {
            id: 7,
            image: "path/to/image8.jpg",
            title: "FRP WALKWAY",
            description: "FRP walkways offering safe and durable pathways for solar installations."
        },
        {
            id: 8,
            image: "path/to/image9.jpg",
            title: "ALUMINIUM MICRO RAIL",
            description: "Aluminium micro rails for precision and stability in solar mounting solutions."
        },
        {
            id: 9,
            image: "path/to/image10.jpg",
            title: "MID CLAMP",
            description: "Mid clamps designed to securely hold solar panels in place."
        },
        {
            id: 10,
            image: "path/to/image11.jpg",
            title: "Z CLAMP",
            description: "Z clamps ensuring a strong grip and stability for solar module mounting."
        },
        {
            id: 11,
            image: "path/to/image12.jpg",
            title: "ALUMINIUM STRUT SECTION",
            description: "Aluminium strut sections for lightweight and durable solar structures."
        },
        {
            id: 12,
            image: "path/to/image13.jpg",
            title: "HDG NUT BOLT",
            description: "High-quality hot-dip galvanized nut bolts for secure solar installations."
        },
        {
            id: 13,
            image: "path/to/image14.jpg",
            title: "SPRING NUT",
            description: "Spring nuts providing flexibility and reliability in solar mounting solutions."
        },
        {
            id: 14,
            image: "path/to/image15.jpg",
            title: "M CLAMP",
            description: "M clamps designed for efficient and secure solar panel mounting."
        },
        {
            id: 15,
            image: "path/to/image16.jpg",
            title: "FISHER CHEMICAL",
            description: "Fisher chemicals for strong and durable connections in solar structures."
        },
        {
            id: 16,
            image: "path/to/image17.jpg",
            title: "THREADED ROD",
            description: "Threaded rods ensuring stability and resilience in solar module mounting."
        },
    ];




    return (
        <MainContainer>
            {/* TOP IMAGE */}
            <div className="text-gray-200 relative w-full overflow-hidden">
                <div className="w-full">
                    <img src={AboutHead} alt="About" className='w-full  bg-cover' />
                </div>

                <div className="flex flex-col w-full absolute top-8 left-10 lg:top-28 lg:left-60">
                    <p className="text-2xl md:text-7xl font-bold ">
                        Our Services
                    </p>
                    <p className="text-xs md:text-3xl">
                        Expert solutions from design to solar plant installations and maintenance."
                    </p>
                </div>
            </div>

            {/* Our Services */}
            <div className="px-8 lg:px-28 mt-5">
                <div className='flex  flex-col items-center'>
                    <p className='text-2xl text-center font-bold'>Solar Power Plant Installations and Services</p>
                    <p className='text-xl text-center mt-2'>Particle Solar Power excels in designing, building, operating, and financing solar power plants. Our comprehensive services cover every aspect, ensuring efficient and sustainable solar solutions for industrial, residential, and commercial projects.</p>
                    <div className="h-[3px] bg-primary-color w-20 my-3" />
                </div>
                <div className="flex flex-wrap">
                    {SERVICES.map((item, index) => (
                        <div key={index} className="w-full md:w-1/2 lg:w-1/4 p-4 h-60">
                            {/* Your card component with item data */}
                            <div className="bg-white p-4 shadow h-full">
                                {item.title}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Our Structured solutions */}
            <div className="px-8 lg:px-28 mt-5">
                <div className='flex  flex-col items-center'>
                    <p className='text-2xl text-center font-bold'>Structured Solutions Tailored for You</p>
                    <p className='text-xl text-center mt-2'>Discover our structured solutions at Particle Solar Power. We offer a diverse range of solar mounting structures, including RCC types, galvanized structures, aluminum rails, and more. With a commitment to quality, innovation, and on-time delivery, we provide customized solutions for all your solar module mounting challenges.</p>
                    <div className="h-[3px] bg-primary-color w-20 my-3" />
                </div>
                <div className="flex flex-wrap">
                    {SOLUTIONS.map((item, index) => (
                        <div key={index} className="w-full md:w-1/2 lg:w-1/4 p-4 h-60">
                            {/* Your card component with item data */}
                            <div className="bg-white p-4 shadow h-full">
                                {item.title}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Our Products */}
            <div className="px-8 lg:px-28 mt-5">
                <div className='flex  flex-col items-center'>
                    <p className='text-2xl text-center font-bold'>High-Quality Solar Mounting Products</p>
                    <p className='text-xl text-center mt-2'>Explore Particle Solar Power's range of premium solar mounting products. From GI strut sections to cable trays, aluminum micro rails to HDG nut bolts, our products ensure durability and efficiency in your solar projects. Trust us for top-quality materials and a comprehensive selection to meet your specific requirements.</p>
                    <div className="h-[3px] bg-primary-color w-20 my-3" />
                </div>
                <div className="flex flex-wrap">
                    {PRODUCTS.map((item, index) => (
                        <div key={index} className="w-full md:w-1/2 lg:w-1/4 p-4 h-60">
                            {/* Your card component with item data */}
                            <div className="bg-white p-4 shadow h-full">
                                {item.title}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </MainContainer>
    )
}

export default Services